import { BaseEvent } from "./event"

export interface AIConfigCreatedEvent extends BaseEvent {}

export interface AIConfigUpdatedEvent extends BaseEvent {}
